import { type ComponentPropsWithoutRef } from 'react';
import { Root } from '@radix-ui/react-accordion';

export type AccordionRootProps = ComponentPropsWithoutRef<typeof Root>;

const AccordionRoot = Root;

export default AccordionRoot;
